// Przechwytywanie zrodla wejscia (ANL-02, D-09 last-touch) w modelu DWUWARSTWOWYM (D-33).
//
// Warstwa 1 — PAMIEC STRONY. Odczyt parametrow kampanii z adresu i trzymanie ich w zmiennej
// modulu. Nic nie ladue na urzadzeniu uzytkownika, wiec art. 399 Prawa komunikacji elektronicznej
// (zgoda na przechowywanie i dostep do informacji w urzadzeniu koncowym) w ogole sie nie stosuje.
// Ta warstwa dziala ZAWSZE, takze przy odmowie zgody — formularz dolacza ja wprost do zadania.
//
// Warstwa 2 — COOKIE, wylacznie po zgodzie marketingowej. Daje jedno: trwalosc miedzy odslonami,
// czyli atrybucje zachowana, gdy ktos wejdzie na /regulamin/ i wroci menu (parametry znikaja
// wtedy z adresu). Bez zgody ta warstwa nie istnieje.
//
// ⛔ Poprzednia wersja (D-10) zapisywala cookie przy kazdym wejsciu, przed decyzja w banerze.
// Cel jest marketingowy (przypisanie leada do kampanii), wiec kategoria „niezbedne" go nie
// obroni — stad przebudowa. Pelny opis wariantow: docs/cookies-inventory.md.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid']
const THIRTY_DAYS = 60 * 60 * 24 * 30
const COOKIE = 'obr_utm'

// Kopia w pamieci — zrodlo prawdy dla zadania z leadem. Zyje tyle, co odslona strony.
let current = null

// Czysty rezolwer last-touch (D-09): jakikolwiek klucz obecny → pelny obiekt 8 kluczy
// (brakujace = ''); zaden → null (wejscie bezposrednie). PURE: bez location/document,
// zeby node mogl go testowac wprost.
export function resolveUtm(search) {
  const params = new URLSearchParams(search)
  if (!UTM_KEYS.some((k) => params.has(k))) return null
  const data = {}
  UTM_KEYS.forEach((k) => { data[k] = params.get(k) || '' })
  return data
}

// Czysty czytnik zgody z ciasteczka CookieYes. Format to pary rozdzielone przecinkami,
// np. „consentid:xyz,consent:yes,necessary:yes,advertisement:yes". Interesuje nas wylacznie
// kategoria marketingowa — w niej siedzi obr_utm w panelu zgod.
// PURE: dostaje surowy lancuch, nie siega do document.
export function hasMarketingConsent(rawCookieJar) {
  const match = /(?:^|;\s*)cookieyes-consent=([^;]*)/.exec(rawCookieJar || '')
  if (!match) return false
  return /(^|,)advertisement:yes(,|$)/.test(decodeURIComponent(match[1]))
}

// Czysty odczyt zapisanej wczesniej wartosci. Wywolywany TYLKO wtedy, gdy zgoda istnieje —
// siegniecie po wlasne cookie tez jest „dostepem do informacji w urzadzeniu".
export function readUtmCookie(rawCookieJar) {
  const match = new RegExp('(?:^|;\s*)' + COOKIE + '=([^;]*)').exec(rawCookieJar || '')
  if (!match) return null
  try {
    const parsed = JSON.parse(decodeURIComponent(match[1]))
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (_) {
    return null // uszkodzone cookie nie moze wywrocic wysylki leada
  }
}

/** Kopia z pamieci dla zadania z leadem. null = brak danych o kampanii. */
export function getUtm() {
  return current
}

function writeCookie(data) {
  const secure = location.protocol === 'https:' ? ';Secure' : ''
  // encodeURIComponent jest OBOWIAZKOWE — surowe przecinki i cudzyslowy z JSON-a psuja cookie.
  document.cookie =
    `${COOKIE}=${encodeURIComponent(JSON.stringify(data))};path=/;max-age=${THIRTY_DAYS};SameSite=Lax${secure}`
}

// Wejscie modulu: ustawia pamiec i — jesli zgoda juz jest — cookie. Gdy zgody nie ma,
// zapis zostaje odlozony do zdarzenia z banera; parametry siedza w adresie przez cala
// odslone, wiec po pozniejszej akceptacji nadal jest co zapisac.
export function captureUtm() {
  const fromUrl = resolveUtm(location.search)
  const consent = hasMarketingConsent(document.cookie)

  current = fromUrl || (consent ? readUtmCookie(document.cookie) : null)

  if (!fromUrl) return

  if (consent) {
    writeCookie(fromUrl)
    return
  }

  // CookieYes oglasza decyzje na obu obiektach zaleznie od wersji skryptu — sluchamy obu,
  // a zapis i tak jest bramkowany ponownym odczytem ciasteczka zgody.
  const onConsent = () => {
    if (hasMarketingConsent(document.cookie)) writeCookie(fromUrl)
  }
  document.addEventListener('cookieyes_consent_update', onConsent)
  window.addEventListener('cookieyes_consent_update', onConsent)
}
